/**
 * Drops a leading "Submitter:" or "Primum Specialist:" speaker label (also "Primum Specialist 2:")
 * from a list card's preview, with its colon and the whitespace or line breaks right after it.
 * Whatever follows on the same line is kept.
 *
 * Card previews only: the card is about the question, and the post page renders speakers from
 * structured data. The post page and legacy-format bodies keep their labels untouched. Applied to
 * the list's snippet, which is a prefix of the body, so the label is at the very start when it is
 * there at all.
 */
export function stripLeadingSpeakerLabel(body: string): string {
  return body.replace(/^\s*(?:Submitter|Primum Specialist(?: \d+)?):\s*/, '');
}
